import { Link, useParams } from "react-router-dom";
import { featuredProjects } from "../data/siteData";

export default function ProjectDetailPage() {
  const { projectSlug } = useParams();
  const project = featuredProjects.find((item) => item.slug === projectSlug);

  if (!project) {
    return (
      <div data-testid="project-not-found-page" className="page-shell page-offset">
        <section className="section-block">
          <div className="container-shell">
            <h1 data-testid="project-not-found-heading" className="section-title">Project not found</h1>
            <Link data-testid="project-not-found-home-link" to="/" className="primary-btn">
              Return Home
            </Link>
          </div>
        </section>
      </div>
    );
  }

  return (
    <div data-testid={`project-detail-page-${project.slug}`} className="page-shell page-offset">
      <section data-testid="project-detail-hero-section" className="section-block">
        <div className="container-shell">
          <p data-testid="project-detail-sector" className="eyebrow">{project.sector}</p>
          <h1 data-testid="project-detail-title" className="section-title">{project.title}</h1>
          <div className="project-detail-image-wrap">
            <img data-testid="project-detail-image" src={project.image} alt={project.title} className="project-detail-image" />
          </div>
        </div>
      </section>

      <section data-testid="project-detail-content-section" className="section-block muted-bg">
        <div className="container-shell detail-grid">
          <article data-testid="project-overview-block" className="detail-card">
            <h2 data-testid="project-overview-heading">Overview</h2>
            <p data-testid="project-overview-text">{project.overview}</p>
          </article>

          <article data-testid="project-scope-block" className="detail-card">
            <h2 data-testid="project-scope-heading">Scope</h2>
            <ul data-testid="project-scope-list" className="detail-list">
              {project.scope.map((item) => (
                <li key={item} data-testid={`project-scope-item-${item.toLowerCase().slice(0, 20).replace(/\s+/g, "-")}`}>
                  {item}
                </li>
              ))}
            </ul>
          </article>

          <article data-testid="project-highlights-block" className="detail-card">
            <h2 data-testid="project-highlights-heading">Execution Highlights</h2>
            <ul data-testid="project-highlights-list" className="detail-list">
              {project.highlights.map((item) => (
                <li key={item} data-testid={`project-highlight-item-${item.toLowerCase().slice(0, 20).replace(/\s+/g, "-")}`}>
                  {item}
                </li>
              ))}
            </ul>
          </article>
        </div>
      </section>

      <section data-testid="project-detail-cta-section" className="section-block">
        <div className="container-shell detail-cta-row">
          <Link data-testid="project-back-to-work-link" to="/gallery" className="secondary-btn">
            Back to Gallery
          </Link>
          <Link data-testid="project-request-quote-link" to="/contact#quote-form" className="primary-btn">
            Request a Quote
          </Link>
        </div>
      </section>
    </div>
  );
}
